"use strict";

import "core-js/modules/web.dom-collections.iterator.js";
import { cssLinks } from "@ttark/css-links";
import ThingsPage from "./body";
import { ThingsHelmet } from "./helmet";
import { useOutletContext } from "@remix-run/react";
import { buildActivityLoader } from "~/utils/activity-loader";
import { jsx } from "react/jsx-runtime";
var links = () => [...cssLinks("routes/activity.100-things")];
var loader = buildActivityLoader("things");
function Page() {
  const {
    for: contextFor
  } = useOutletContext();
  if (contextFor === "head") {
    return /* @__PURE__ */jsx(ThingsHelmet, {});
  } else {
    return /* @__PURE__ */jsx(ThingsPage, {});
  }
}
export { Page as default, links };